<template>
<div class="box">
    <img src="../assets/homeShow.png" alt="">
</div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  methods: {
    foo() {
      var self = this;
      setTimeout(function() {
        self.$router.push({
          name: "Home",
          params: {
            page: "1"
          }
        });
      }, 2000);
    }
  },
  mounted() {
    this.foo();
    var self = this;
  }
};
</script>

<style scoped>
img {
  width: 100%;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/exhibition.vue